export const DOWNLOAD_NICE_DCV_LINK = "https://download.nice-dcv.com/"
